import React from 'react';
import I18n from 'i18n-js';

export function InstructionStep(props) {
  return (
    <div className="price-guide-tool-instructions__steps__step">
      <div className="price-guide-tool-instructions__steps__step__number">
        <span className="text-title-700" aria-hidden="true">{props.number}</span>
        <span className="visually-hidden">{props.altText}</span>
      </div>
      <div className="price-guide-tool-instructions__steps__step__content">
        <h5 className="text-title-500 mb-2">
          {props.title}
        </h5>
        <p className="text-default-400 mb-0">
          {props.description}
        </p>
      </div>
    </div>
  );
}

export default function PriceGuideToolInstructions() {
  return (
    <div className="price-guide-tool-instructions">
      <h3 className="price-guide-tool-instructions__title">
        {I18n.t('discovery.priceGuideTool.index.instructions.title')}
      </h3>
      <div className="price-guide-tool-instructions__steps">
        <InstructionStep
          title={I18n.t('discovery.priceGuideTool.index.instructions.step1Title')}
          description={I18n.t('discovery.priceGuideTool.index.instructions.step1Description')}
          altText={I18n.t('discovery.priceGuideTool.index.instructions.step1AltText')}
          number={1}
        />
        <InstructionStep
          title={I18n.t('discovery.priceGuideTool.index.instructions.step2Title')}
          description={I18n.t('discovery.priceGuideTool.index.instructions.step2Description')}
          altText={I18n.t('discovery.priceGuideTool.index.instructions.step2AltText')}
          number={2}
        />
        <InstructionStep
          title={I18n.t('discovery.priceGuideTool.index.instructions.step3Title')}
          description={I18n.t('discovery.priceGuideTool.index.instructions.step3Description')}
          altText={I18n.t('discovery.priceGuideTool.index.instructions.step3AltText')}
          number={3}
        />
      </div>
    </div>
  );
}
